import "./App.css";
import Login from "./features/auth/Login";
import { AuthProvider } from "./context/AuthContext";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import PublicRoute from "./routes/PublicRoute";
import PrivateRoute from "./routes/PrivateRoute";
import Dashboard from "./features/dashboard/Dashboard";
import AssessmentResults from "./features/dashboard/pages/AssessmentResults";
import StudentMonthlyReport from "./features/dashboard/components/Reports/StudentMonthlyReport";
import StudentMonthlyReportPage from "./features/dashboard/pages/StudentMonthlyReportPage";
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route path="/" element={<Navigate to="/overview" />} />
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="/assessments/:assessmentId/results"
            element={<AssessmentResults />}
          />
          <Route
            path="/students/:studentId/monthly-report"
            element={<StudentMonthlyReportPage />}
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
